import {styled} from '@mui/material';
import {DateCalendar} from '@mui/x-date-pickers';

export const StyledDateCalendar = styled(DateCalendar)`
	width: 100%;

	& .MuiPickersCalendarHeader-label {
		text-transform: capitalize;
		color: ${({theme}) => theme.palette.text.primary};
		font-weight: 600;
	}

	& .MuiPickersCalendarHeader-switchViewButton {
		display: none;
	}
`;
